#import "../fragments/chat-settings-fragment.graphql"

query GetChatSettings {
    chatSettings {
        ...ChatSettingsFragment
    }
}
